<template>
  <div id="adminSelenaViews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Form Builder</router-link>
      </li>
    </ol>
      <div class="container-fluid card-title-admin">
        <h1>Form Builder</h1>
    </div>
     <div class="container-fluid">
      <!--div class="card">
        <div class="tab-content noborder">
          <div class="card-body">
            
          </div>
        </div>
      </!--div>-->
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-lg-12 text-left">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onClickNew"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckCustomer"
                :results="tableNationResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabNationDetail" role="tabpanel">
            <div class="card-body" style="padding: 30px;box-shadow:none!important;">
              <div class="row">
                <div class="col-12 text-right">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabadminSettingUserButton"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabadminSettingUserButton"
                        role="tab"
                        aria-controls="tabadminSettingUserButton"
                        v-on:click="ontabInfoButton"  
                      >
                        <i class=""></i>
                        <span>Info</span>
                      </button>
                    </li>
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingAddressButton"
                        class="nav-link"
                        type="button"
                        data-toggle="tab"
                        href="#tabadminSettingAddressButton"
                        role="tab"
                        aria-controls="tabadminSettingAddressButton"
                        v-on:click="ontabinfoFieldButton"  
                      >
                        <i class=""></i>
                        <span>Campi Form</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="tab-content" style="border:0px;box-shadow:none!important;">
                <div class="card-body active tab-pane " id="detailForm"  role="tabpanel" style="padding:2rem;box-shadow:none!important;padding-top: 0px;">
                  <div class="row">
                    <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      <p>Shortcode: [form id={{ rowIdSelected }} form]</p>
                    </div>
                    <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                    </div>
                    <pageDetail
                      functions="AdminSettingNation"
                      :configurations="detailNationConfiguration"
                      :jsonValue="detailNationData"
                    ></pageDetail>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="cancelNewNation"
                      ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="saveNewNation"
                      ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                    </div>
                  </div>
                </div>
                <div class="card-body tab-pane nopadding" id="detailFormField" role="tabpanel" style="padding:2rem;box-shadow:none!important;padding-top: 0px;border:0px solid #fff">
                  <div class="tab-content" style="border:0px;box-shadow:none!important;">
                    <div class="tab-pane nopadding active" id="tabTableFormField" role="tabpanel" style="box-shadow:none!important;">
                      <div class="row align-btn">
                        <div class="col-lg-12 text-left">
                          <button
                            id="btnAddFormField"
                            type="button"
                            class="btn btn-primary"
                            @click="onClickNewFormField"
                          >
                            <i class="fa fa-plus"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <bootstrapTable
                          :configurations="tableConfigurationFormField"
                          :datas="tableDataFormField"
                          id="tableContentsFormField"
                          ref="tableContentsFormField"
                          :results="tableNationResultFormField"
                        ></bootstrapTable>
                      </div>
                    </div>
                    <div class="tab-pane nopadding" id="tabDetailFormField" role="tabpanel" style="padding:2rem !important;box-shadow:none!important;padding-top: 0px; border:0px solid #fff">
                      <div v-if="rowIdSelectedFormField > 0">
                        <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                        <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                      <pageDetail
                        functions="AdminSettingNationFormField"
                        :configurations="detailNationConfigurationFormField"
                        :jsonValue="detailNationDataFormField"
                      ></pageDetail>
                      <div class="container-value-form-builder-value" v-if="rowIdSelectedFormField > 0 && detailNationDataFormField.showValueFormBuilderField">
                        <div class="row">
                          <div class="col-12">
                            <hr>
                          </div>
                        </div>
                        <div class="row" style="margin-bottom:15px;">
                          <div class="col-10 align-self-center">
                            <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Valori multipli</h1>
                          </div>
                          <div class="col-2 align-self-center text-right">
                            <button
                              type="button"
                              class="btn btn-primary"
                              @click="addValueFormBuilderField(rowIdSelectedFormField)"
                            ><i class="fa fa-plus"></i>&nbsp;Aggiungi</button>
                          </div>
                        </div>
                        <div >
                          <div class="row" style="border-bottom: 1px solid #ededed;margin-bottom: 20px;padding-bottom: 25px;" v-for="valueFormBuilder in detailNationDataFormField.valueFormBuilderField" :key="valueFormBuilder.id">
                            <div class="col-2 align-self-center">
                              <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                                @click="removeValueFormBuilderField(valueFormBuilder.id)"
                              ><i class="fa fa-trash"></i></button>
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-dismiss="modal"
                                @click="openListValueFatherFormBuilderField(valueFormBuilder.id)"
                              ><i class="fa fa-list"></i></button>

                              <!-- popup valori collegati al valore principale -->
                              <div class="modal" :id="'modalValueFatherFormBuilderField' + valueFormBuilder.id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                  <div class="modal-content padding">
                                    <div class="modal-header">
                                      <div class="row">
                                        <div class="col-10 align-self-center">
                                          <h4 class="modal-title w-100 font-weight-bold">
                                            Valori collegati
                                          </h4>
                                        </div>
                                        <div class="col-2 align-self-center text-right">
                                          <button type="button" class="btn btn-primary" @click="addValueFatherFormBuilderField(valueFormBuilder.id)"><i class="fa fa-plus"></i>&nbsp;Aggiungi</button>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modal-body mx-12">
                                      <div class="md-form mb-12" >
                                        <div class="row" v-for="valueFatherFormBuilder in valueFormBuilder.valueFatherFormBuilderField" :key="valueFatherFormBuilder.id">
                                          <div class="col-2 align-self-center">
                                            <button
                                              type="button"
                                              class="btn btn-danger"
                                              data-dismiss="modal"
                                              @click="removeValueFatherFormBuilderField(valueFatherFormBuilder.id, valueFatherFormBuilder.old)"
                                            ><i class="fa fa-trash"></i></button>
                                          </div>
                                          <div class="col-10 align-self-center">
                                            <div class="row">
                                              <div class="col-4 align-self-center">
                                                <label style="margin-bottom:3px;">Ordinamento</label>
                                                <input class="form-control" :id="'order'" :name="'order'" v-model="valueFatherFormBuilder.order">
                                              </div>
                                              <div class="col-8 align-self-center">
                                                <label style="margin-bottom:3px;">Valore</label>
                                                <input class="form-control" :id="'value'" :name="'value'" v-model="valueFatherFormBuilder.value">
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div class="col-10 align-self-center" style="margin-top:5px;">
                                                <label style="margin-bottom:3px;">Descrizione</label>
                                                <input class="form-control" :id="'description'" :name="'description'" v-model="valueFatherFormBuilder.description">
                                              </div>
                                              <div class="col-2 align-self-center text-center" style="margin-top:5px;">
                                                <label style="margin-bottom:3px;">Default</label><br>
                                                <label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" >
                                                  <input type="checkbox" class="switch-input" id="default" :name="'default'" :checked="valueFatherFormBuilder.checked" v-model="valueFatherFormBuilder.default"  />
                                                  <span class="switch-slider" data-on data-off></span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- end popup valori collegati al valore principale -->
                            </div>
                            <div class="col-6 align-self-center">
                              <div class="row">
                                <div class="col-4 align-self-center">
                                  <label style="margin-bottom:3px;">Ordinamento</label>
                                  <input class="form-control" :id="'order'" :name="'order'" v-model="valueFormBuilder.order">
                                </div>
                                <div class="col-8 align-self-center">
                                  <label style="margin-bottom:3px;">Valore {{ valueFormBuilder.id }}</label>
                                  <input class="form-control" :id="'value'" :name="'value'" v-model="valueFormBuilder.value">
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-10 align-self-center" style="margin-top:5px;">
                                  <label style="margin-bottom:3px;">Descrizione {{ valueFormBuilder.id }}</label>
                                  <input class="form-control" :id="'description'" :name="'description'" v-model="valueFormBuilder.description">
                                </div>
                                <div class="col-2 align-self-center text-center" style="margin-top:5px;">
                                  <label style="margin-bottom:3px;" for="default">Default</label><br>
                                  <label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" >
                                    <input type="checkbox" class="switch-input" id="default" :name="'default'" :checked="valueFormBuilder.checked" v-model="valueFormBuilder.default"  />
                                    <span class="switch-slider" data-on data-off></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-4 align-self-center">
                              <div class="row">
                                <div class="col-6 align-self-center" v-if="valueFormBuilder.showFieldImage">
                                  <label style="margin-bottom:3px;">Immagine {{ valueFormBuilder.id }}</label>
                                  <input class="form-control" :name="'img'" :id="'img'" :class="'img' + valueFormBuilder.id" v-model="valueFormBuilder.img">
                                  <input type="hidden" :name="'base64'" :class="'base64' + valueFormBuilder.id" :id="'base64'" v-model="valueFormBuilder.base64">
                                </div>
                                <div class="col-6 align-self-center" v-if="valueFormBuilder.showFieldImage">
                                  <label
                                    :for="'imgValueFormBuilderField' + valueFormBuilder.id"
                                    class="custom-file-upload"
                                    style="padding: 20px"
                                    v-cloak
                                    @drop.prevent="onChangeImageAgg"
                                    @dragover.prevent
                                  >
                                    SFOGLIA / UPLOAD AREA
                                  </label>
                                  <input
                                    type="file"
                                    class="imgValueFormBuilderField"
                                    :data-attr-id-value="valueFormBuilder.id"
                                    :id="'imgValueFormBuilderField' + valueFormBuilder.id"
                                    :name="'imgValueFormBuilderField' + valueFormBuilder.id"
                                    @change="onChangeImageAgg"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-top:15px;">
                        <div class="col-12 text-right">
                          <button
                            type="button"
                            class="btn btn-danger"
                            data-dismiss="modal"
                            @click="cancelNewFormBuilderField"
                          ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="saveNewBuilderField"
                          ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminSelenaViews",
  components: {
    BootstrapTable,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      detailNationConfiguration: [],
      detailNationConfigurationFormField: [],
      tableNationResult: [],
      tableNationResultFormField: [],
      detailNationData: {},
      detailNationDataFormField: {},
      tableConfiguration: [],
      tableConfigurationFormField: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },

      valueFormBuilderValue: [],
      rowIdSelected: 0,
      rowIdSelectedFormField: 0,
      valueInputFormBuilderFiled: 0,
      tableData: [],
      tableDataFormField: [],
      disableButton: true,
      url: window.location.pathname
    };
  },
  created() {
    var adminSelenaViews = this;

    spinnerHelpers.show();
    adminSelenaViews.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      adminSelenaViews.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminSelenaViews.detailNationConfiguration = result.data.tabsConfigurations[0].pageConfigurations;

      adminSelenaViews.tableConfigurationFormField = result.data.tablesConfigurations[1].tablesConfigurations;
      adminSelenaViews.detailNationConfigurationFormField = result.data.tabsConfigurations[1].pageConfigurations; 

      adminSelenaViews.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminSelenaViews = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }
      
      formBuilderServices.getAll(ln,function(result) {
        adminSelenaViews.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    loadTableFormBuilderField(ln, id) {
      var adminSelenaViews = this;
      formBuilderServices.getAllById(ln, id, function(result) {
        adminSelenaViews.tableDataFormField = result.data;

        $("#detailFormField").addClass("active");
        $("#detailForm").removeClass("active");
        $("#tabDetailFormField").removeClass("active");
      });
    },
    ontabInfoButton() {    
        $("#detailForm").addClass("active");
        $("#detailFormField").removeClass("active");

        $("#tabDetailFormField").removeClass("active");
        $("#tabTableFormField").addClass("active");
        
    },
    ontabinfoFieldButton(){
      var adminSelenaViews = this;
      var ln = 1;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }

      var id = adminSelenaViews.rowIdSelected;
      adminSelenaViews.loadTableFormBuilderField(ln, id);
    },
    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminSelenaViews = this;
      adminSelenaViews.loadTable(value);
      spinnerHelpers.hide();
    },
    FormBuilderFormatter(value, row, index, field) {
      var adminSelenaViews = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminSelenaViews.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
        html +=
        '<button class="btn btn-info" onclick="adminSelenaViews.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o" style="color:#fff;"/></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminSelenaViews.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      return html;
    },
    FormBuilderFieldFormatter(value, row, index, field) {
      var adminSelenaViews = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminSelenaViews.__vue__.viewDatailInfoField(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminSelenaViews.__vue__.deleteFormBuilderField(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      return html;
    },

    viewDatailInfo(id){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function(i, row) {
        if (adminSelenaViews.rowIdSelected == row.id) {
          adminSelenaViews.detailNationData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      $("#detailForm").addClass("active");
      $("#tabDetailFormField").removeClass("active");
      $("#detailFormField").removeClass("active");
      spinnerHelpers.hide(); 

    },

    viewDatailInfoField(id){
      spinnerHelpers.show();
      var adminSelenaViews = this, showImage = true;
      this.rowIdSelectedFormField = id;
      $.each(adminSelenaViews.tableDataFormField, function(i, row) {
        if (adminSelenaViews.rowIdSelectedFormField == row.id) {
          adminSelenaViews.detailNationDataFormField = row;
        }
      });

      $("#tabDetailFormField").addClass("active");
      $("#tabTableFormField").removeClass("active");
      spinnerHelpers.hide();
    },
    clone(id) {
      var adminSettingNews = this;
      spinnerHelpers.show();
      formBuilderServices.clone(id, function () {
        notificationHelpers.success(dictionaryHelpers.getDictionary("CloneCompleted"));
        var ln = adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSettingNews.loadTable(ln);
      });
    },
    delete(id) {
      var adminSelenaViews = this;
      spinnerHelpers.show();
      formBuilderServices.del(id, function() {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        var ln = adminSelenaViews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSelenaViews.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },
    deleteFormBuilderField(id){
       var adminSelenaViews = this;
        spinnerHelpers.show();
        formBuilderServices.deleteFormBuilderField(id, function() {
          notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
          var ln = adminSelenaViews.pageValueSelected.languagePageSetting.idLanguage;
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminSelenaViews.loadTableFormBuilderField(ln, adminSelenaViews.rowIdSelected);
          window.scrollTo(0, 0);
        });
    },
    onClickNew() {
      spinnerHelpers.show();
      var adminSelenaViews = this;
      adminSelenaViews.rowIdSelected = 0;

     // this.detailNationData = {};
      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      $("#detailForm").addClass("active");
      $("#detailFormField").removeClass("active");
      $("#tabDetailFormField").removeClass("active");
      spinnerHelpers.hide();
    },

    onClickNewFormField(){
      spinnerHelpers.show();
      var adminSelenaViews = this;

      adminSelenaViews.rowIdSelectedFormField = 0;

      $("#tabDetailFormField").addClass("active");
      $("#tabTableFormField").removeClass("active");

      spinnerHelpers.hide();
    },
    cancelNewNation(){
      spinnerHelpers.show();
      this.detailNationData = {};
      $("#tabTable").addClass("active");
      $("#tabNationDetail").removeClass("active");
      $("#detailForm").addClass("active");
      $("#detailFormField").removeClass("active");
      spinnerHelpers.hide();
    },
    cancelNewFormBuilderField(){
      this.detailNationDataFormField = {};
      spinnerHelpers.show();
      $("#tabDetailFormField").removeClass("active");
      $("#tabTableFormField").addClass("active");
      spinnerHelpers.hide();
    },
    saveNewBuilderField(){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.detailNationDataFormField.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      this.detailNationDataFormField.form_builder_id = this.rowIdSelected; 

      if (functionHelpers.isValued(this.rowIdSelectedFormField) && this.rowIdSelectedFormField > 0) {
        this.detailNationDataFormField.id = this.rowIdSelectedFormField;
    
        formBuilderServices.updateFormBuilderField(this.detailNationDataFormField, function (result) {
          notificationHelpers.success(adminSelenaViews.updateCompleted);
          adminSelenaViews.loadTableFormBuilderField(1, adminSelenaViews.rowIdSelected);
          $("#tabDetailFormField").removeClass("active");
          $("#tabTableFormField").addClass("active");

        })
      } else {
        formBuilderServices.insertFormBuilderField(this.detailNationDataFormField, function (result) {
          notificationHelpers.success(adminSelenaViews.insertCompleted);
          adminSelenaViews.loadTableFormBuilderField(1, adminSelenaViews.rowIdSelected);
          $("#tabDetailFormField").removeClass("active");
          $("#tabTableFormField").addClass("active");
        })
      }
    },
    saveNewNation(){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.detailNationData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        this.detailNationData.id = this.rowIdSelected;
    
        formBuilderServices.update(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.updateCompleted);
          adminSelenaViews.loadTable();
          $('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');
          $("#detailForm").addClass("active");
          $("#detailFormField").removeClass("active");

        })
      } else {
        formBuilderServices.insert(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.insertCompleted);
          adminSelenaViews.loadTable();
          $('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');
          $("#detailForm").addClass("active");
          $("#detailFormField").removeClass("active");
        })
      }
    },
    changeFieldType(field, value) {
      var adminSelenaViews = this;
      //adminSelenaViews.detailNationDataFormField.valueFormBuilderField = [];
      adminSelenaViews.valueInputFormBuilderFiled = value;
      if(value == '6' || value == '7' || value == '8'){
        adminSelenaViews.detailNationDataFormField.showValueFormBuilderField = true;
        $('#value').hide();
        $('label[for=value]').hide();
      }else{
        adminSelenaViews.detailNationDataFormField.showValueFormBuilderField = false;
        $('#value').show();
        $('label[for=value]').show();
      }
    },
    addValueFormBuilderField(id){
      var adminSelenaViews = this, showImage = true;
      var data = {
        id: adminSelenaViews.detailNationDataFormField.valueFormBuilderField.length + 1,
        value: '',
        default: '',
        img: '',
        old: false,
        order: adminSelenaViews.detailNationDataFormField.valueFormBuilderField.length + 1,
        showFieldImage: showImage
      }
      adminSelenaViews.detailNationDataFormField.valueFormBuilderField.push(data);
    },
    addValueFatherFormBuilderField(id){
      var adminSelenaViews = this, showImage = true;
      $.each(adminSelenaViews.detailNationDataFormField.valueFormBuilderField, function(i, row) {
        if (id == row.id) {
          var data = {
            id: adminSelenaViews.detailNationDataFormField.valueFormBuilderField[i].valueFatherFormBuilderField.length + 1,
            value: '',
            default: '',
            img: '',
            old: false,
            order: adminSelenaViews.detailNationDataFormField.valueFormBuilderField[i].valueFatherFormBuilderField.length + 1,
            showFieldImage: showImage
          }
          adminSelenaViews.detailNationDataFormField.valueFormBuilderField[i].valueFatherFormBuilderField.push(data);
        }
      });

    },
    removeValueFatherFormBuilderField(id, onlyRefresh){
      var adminSelenaViews = this, deleteOrReload = false;

      if(onlyRefresh){
        deleteOrReload = true;
      }
       
      if(deleteOrReload){
        formBuilderServices.deleteValueFatherFormBuilderField(id, function() {
          formBuilderServices.getAllById(1, adminSelenaViews.rowIdSelected, function(result) {
            adminSelenaViews.tableDataFormField = result.data;
            $.each(adminSelenaViews.tableDataFormField, function(i, row) {
              if (adminSelenaViews.rowIdSelectedFormField == row.id) {
                adminSelenaViews.detailNationDataFormField = row;
                notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
              }
            });
          });
        });
      }else{
        formBuilderServices.getAllById(1, adminSelenaViews.rowIdSelected, function(result) {
          adminSelenaViews.tableDataFormField = result.data;
          $.each(adminSelenaViews.tableDataFormField, function(i, row) {
            if (adminSelenaViews.rowIdSelectedFormField == row.id) {
              adminSelenaViews.detailNationDataFormField = row;
              notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
            }
          });
        });
      }
    },
    removeValueFormBuilderField(id){
      var adminSelenaViews = this, deleteOrReload = false;

       $.each(adminSelenaViews.detailNationDataFormField.valueFormBuilderField, function(i, row) {
        if (id == row.id) {

          deleteOrReload = adminSelenaViews.detailNationDataFormField.valueFormBuilderField[i].old;
        }
      });

      if(deleteOrReload){
        formBuilderServices.deleteValueFormBuilderField(id, function() {
          formBuilderServices.getAllById(1, adminSelenaViews.rowIdSelected, function(result) {
            adminSelenaViews.tableDataFormField = result.data;
            $.each(adminSelenaViews.tableDataFormField, function(i, row) {
              if (adminSelenaViews.rowIdSelectedFormField == row.id) {
                adminSelenaViews.detailNationDataFormField = row;
                notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
              }
            });
          });
        });
      }else{
        formBuilderServices.getAllById(1, adminSelenaViews.rowIdSelected, function(result) {
          adminSelenaViews.tableDataFormField = result.data;
          $.each(adminSelenaViews.tableDataFormField, function(i, row) {
            if (adminSelenaViews.rowIdSelectedFormField == row.id) {
              adminSelenaViews.detailNationDataFormField = row;
              notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
            }
          });
        });
      }
    },
    openListValueFatherFormBuilderField(id){
      var adminCrmItems = this;
      $('#modalValueFatherFormBuilderField' + id).modal("show");
    },
    onChangeImageAgg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImageAgg(e.target.id, files[i].name, files[i]);
      }
    },
    createImageAgg(id, name, file) {
      var idAttr = $('#' + id).attr('data-attr-id-value');
      var adminCrmItems = this;
      var jsonImgAggUpload = this;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          imgName: name,
          imgBase64: e.target.result,
        };

        $.each(adminCrmItems.detailNationDataFormField.valueFormBuilderField, function(i, row) {
          if (idAttr == row.id) {
            adminCrmItems.detailNationDataFormField.valueFormBuilderField[i].img = name;
            adminCrmItems.detailNationDataFormField.valueFormBuilderField[i].base64 = e.target.result;
          }
        });
      };

      reader.readAsDataURL(file);
    },
  }
};
</script>
<style>

.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}


.nav-tabs .nav-item {
  width: 50%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}



/* style for upload area */

.imgValueFormBuilderField[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  border: 3px dashed #ededed;
  border-radius: 10px;
}
/* end style for upload area */
</style>
